import React, { FC } from 'react';

interface Props {
    data: dataItem[];
    style?: React.CSSProperties;
}
type dataItem = {
    label: string;
    colors: string[];
};
const LegendAlt: FC<Props> = ({ data, style = {} }) => {
    return (
        <div style={style} className="flex justify-center gap-6 items-center">
            {data.map((item) => {
                return (
                    <div key={item.label} className="items-center flex gap-1">
                        <div className="flex">
                            <p style={{ background: item.colors[0] }} className={`legend-alt-size `}></p>
                            <p style={{ background: item.colors[1] }} className={`legend-alt-size `}></p>
                        </div>
                        <span className="text-greyFont font-xs">{item.label}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default LegendAlt;
